/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_2_DescInputs */

const en_mk_agent_2_desc = /** @type {(inputs: Mk_Agent_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every edit arrives as a proposal with a diff — including drift proposals when the code no longer matches the PRD. Apply, reject, or ask for another version.`)
};

const id_mk_agent_2_desc = /** @type {(inputs: Mk_Agent_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap suntingan datang sebagai usulan dengan diff — termasuk usulan drift saat kode tidak lagi cocok dengan PRD. Terapkan, tolak, atau minta versi lain.`)
};

/**
* | output |
* | --- |
* | "Every edit arrives as a proposal with a diff — including drift proposals when the code no longer matches the PRD. Apply, reject, or ask for another version." |
*
* @param {Mk_Agent_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_2_desc = /** @type {((inputs?: Mk_Agent_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_2_desc(inputs)
	return en_mk_agent_2_desc(inputs)
});